import React from "react";
import { setGlobal } from "reactn";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { metadataActions } from "../actions/metadata.actions";
import { missionId } from "utils/urls";
import { isErrorPage, pageStatus } from "utils/pageStatus";

import ErrorPage from "pages/ErrorPage/ErrorPage";

class Startup extends React.Component {
  static propTypes = {
    connection: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: "",
      isErrorPage: isErrorPage(),
      pageStatus: pageStatus(),
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(metadataActions.receiveMetadata(missionId));
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.data !== undefined) {
      state.data = nextProps.data;
      setGlobal(state.data);
    }
    return state;
  }

  render() {
    const { isErrorPage, pageStatus } = this.state;
    if (isErrorPage) return <ErrorPage pageStatus={pageStatus} />;
    return this.props.data ? this.props.children : null;
  }
}

function mapStateToProps(state) {
  const { data } = state.metadata;
  return {
    data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    metadata: (missionId) =>
      dispatch(metadataActions.receiveMetadata(missionId)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Startup);
